import { render, staticRenderFns } from "./voucherCreateMutilCrmSerial.vue?vue&type=template&id=5e4d771d&scoped=true&"
import script from "./voucherCreateMutilCrmSerial.vue?vue&type=script&lang=js&"
export * from "./voucherCreateMutilCrmSerial.vue?vue&type=script&lang=js&"
import style0 from "./voucherCreateMutilCrmSerial.vue?vue&type=style&index=0&id=5e4d771d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d771d",
  null
  
)

export default component.exports